import React, { useCallback, useState } from 'react';
import { useCallbackObservable, useObservable } from 'react-use-observable';

import { App, Button } from 'antd';

import { saveAs } from 'file-saver';
import { formatDate } from 'helpers/date';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import chargebackService from 'v2/services/chargeback';

import { Icon } from '@eduzz/ui-antd-theme';

const ExportChargeback = () => {
  const { modal } = App.useApp();
  const [loading, setLoading] = useState<boolean>(false);
  const [totalItems] = useObservable(() => chargebackService.getTotalItems(), []);

  const [exportReport] = useCallbackObservable(() => {
    setLoading(true);
    return chargebackService.export().pipe(
      tap(data => {
        const dateExport = formatDate(new Date(), 'dd-MM-yyyy');
        const fileExport = new Blob([data as any], { type: 'text/csv; charset=utf-8' });
        saveAs(fileExport, `chargeback-${dateExport}.csv`);
        setLoading(false);
      }),
      catchError(() => {
        setLoading(false);
        return of(true);
      })
    );
  }, []);

  const handleExport = useCallback(() => {
    if (totalItems > 3000) {
      modal.warning({
        title: 'Atenção',
        content: 'É possível exportar no máximo 3 mil registros por relatório. Refaça o filtro para poder exportar.'
      });
      return;
    }

    exportReport();
  }, [exportReport, modal, totalItems]);

  return (
    <Button
      color='default'
      variant='filled'
      disabled={!totalItems || loading}
      onClick={handleExport}
      loading={loading}
      icon={<Icon.Download size={16} />}
    >
      {!loading ? 'Exportar' : 'Exportando...'}
    </Button>
  );
};

export default ExportChargeback;
